import { classNames } from 'libs/react';
import { React } from 'libs/react';
import './LanguageSelectOption.scss';
/**
 * @component LanguageSelectOption
 * @since 1.0.0
 */
export function LanguageSelectOption(props) {
    const { style, value } = Object.assign({ style: 'normal' }, props);
    /**
     * @function onClick
     * @since 1.0.0
     * @hidden
     */
    function onClick() {
        if (props.onSelect) {
            props.onSelect(value);
        }
    }
    /**
     * @function onMouseEnter
     * @since 1.0.0
     * @hidden
     */
    function onMouseEnter() {
        if (props.onMouseEnter) {
            props.onMouseEnter(value);
        }
    }
    /**
     * @function onMouseLeave
     * @since 1.0.0
     * @hidden
     */
    function onMouseLeave() {
        if (props.onMouseLeave) {
            props.onMouseLeave(value);
        }
    }
    const className = classNames('language-select-option', 'language-select-option--' + style, props.className);
    return (React.createElement("div", { className: className, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: onClick }, value.name));
}
